import Vue        from 'vue'
import VueRouter  from 'vue-router'
import menu       from '../confnav' // menu + routes
import { TokenService } from '../services/storage'
import { cacheData } from "../store/cache.module"
import { scopeCredential } from "../scopeCredential"

/**************** Routeur  *********************/
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: menu.routes
})

/**************** Authentification ******************/
router.beforeEach((to, from, next) => {
  const isPublic          = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn          = !!TokenService.getToken();
  const appmode           = to.meta.appmode || ['compensea']
  if (!isPublic && !loggedIn) {
    return next({ path:'/login', query: {redirect: to.fullPath} })  // Store the full path to redirect the user to after login
  }
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/') // Do not allow user to visit login page or register page if they are logged in
  }
  //App module control
  if( cacheData.user.usr_role !== undefined && appmode.indexOf( cacheData.appModule ) === -1 ){
    return next('/forbidden')
  }

  if( cacheData.user.usr_role !== undefined && scopeCredential[to.name] !== undefined && ( scopeCredential[to.name]['read'] !== undefined || scopeCredential[to.name]['edit'] !== undefined ) ){
    scopeCredential[to.name]['edit'] = scopeCredential[to.name]['edit'] || []
    scopeCredential[to.name]['read'] = scopeCredential[to.name]['read'] || []
    let read = scopeCredential[to.name]['read'].indexOf( cacheData.user.usr_role )
    let edit = scopeCredential[to.name]['edit'].indexOf( cacheData.user.usr_role )
    if( read < 0 && edit < 0 ){
      return next('/forbidden')
    }
  }

  next()
})

export default router